import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CurrentUserModel } from '../models/account-ledger.model';
import { AuthService } from '../services/auth.service';

@Injectable()
export class CanActivatePriceList implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    return this.authService.getLoginInfo().pipe(
      map((user: CurrentUserModel) => {
        if (user && user.isStaffAccount) {
          return true;
        } else {
          this.router.navigateByUrl('/quotes/openQuotes');
          return true;
        }
      })
    );
  }
}
